import { Button } from '@factorialco/factorial-one-react'
import { ArrowCycle, Spinner } from '@factorialco/factorial-one-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { Modals } from 'modules/integrations/components/SyncButton/Modals'
import { useIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

export const SyncButton = () => {
  const { isSyncRunning, openModal, syncEnabled, marketplaceIntegration } =
    useIntegrationsSyncContext()

  if (!syncEnabled || !marketplaceIntegration) return null

  return (
    <>
      <Button
        loading={isSyncRunning}
        icon={isSyncRunning ? Spinner : ArrowCycle}
        label={
          isSyncRunning
            ? i18n.t('compensations.integrations.syncing')
            : i18n.t('compensations.integrations.sync_action', {
                integration_name: marketplaceIntegration.name,
              })
        }
        onClick={openModal}
      />
      <Modals />
    </>
  )
}
